import { render, staticRenderFns } from "./CorpsTable.vue?vue&type=template&id=27bba2da&scoped=true"
import script from "./CorpsTable.vue?vue&type=script&lang=ts"
export * from "./CorpsTable.vue?vue&type=script&lang=ts"
import style0 from "./CorpsTable.vue?vue&type=style&index=0&id=27bba2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bba2da",
  null
  
)

export default component.exports